import styled from 'styled-components';
import {
  Modal as SemanticModal,
  TextArea as SemanticTextArea,
} from 'semantic-ui-react';
import { Button, Header } from '@playbookux/playbook-web-core';

const Modal = styled(SemanticModal)`
  padding: 20px 40px;
`;

const Text = styled(Header)``;

const ButtonSave = styled(Button)`
  width: 100px;
`;

const ContainerButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

const TextArea = styled(SemanticTextArea)`
  &&& {
    height: 75px;
    resize: none;
  }
`;

export {
  ButtonSave,
  ContainerButton,
  Modal,
  Text,
  TextArea,
};
